import React from 'react';
import OnlineRegRedirect from '../views/PortfolioMasonry/OnlineRegRedirect';

const PortfolioMasonryPage = () => {
  return <OnlineRegRedirect />;
};

export default PortfolioMasonryPage;